import { render, staticRenderFns } from "./RotatableCamera.vue?vue&type=template&id=a3d5fa8e&scoped=true&"
import script from "./RotatableCamera.vue?vue&type=script&lang=js&"
export * from "./RotatableCamera.vue?vue&type=script&lang=js&"
import style0 from "./RotatableCamera.vue?vue&type=style&index=0&id=a3d5fa8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3d5fa8e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
